import { Injectable } from '@angular/core';
import { Http, RequestOptions, Response } from '@angular/http';
import { BhtpBaseService, ApiResponseContainer } from '@bhtp-client-api/base';

import { Observable, Observer } from 'rxjs';

import { CustomerFullData } from './../models/customer-full-data.model';
import { CustomerSimpleData } from './../models/customer-simple-data.model';

@Injectable()
export class CustomerService extends BhtpBaseService {

    constructor(private http: Http) { super(); }

    public searchCustomer(agentCode: string, searchText: string, pageNumber: string, pageSize: string): Observable<Array<CustomerSimpleData>> {
        let customerResults: Array<CustomerSimpleData> = null;
        let path: string = this.getFullUrl(`/v1/CustomerSearch/${agentCode}/${pageNumber}/${pageSize}?searchText=${searchText}`);
        let options: RequestOptions = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);

        return this.http.get(path, options)
            .map((res: Response) => {
                return (<ApiResponseContainer<CustomerSimpleData[]>>res.json()).response;
            });
    }

    public getCustomerById(agentCode: string, customerId: string): Observable<CustomerFullData> {
        let customerResult: CustomerFullData = null;
        let path: string = this.getFullUrl(`/v1/Customer/${agentCode}/${customerId}`);
        let options: RequestOptions = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);

        return this.http.get(path, options)
            .map((res: Response) => {
                return (<ApiResponseContainer<CustomerFullData>>res.json()).response;
            });
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/services/customer.service.ts